import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Region} from '../../pages/user-management/region/region.model';

export interface RegionRequestParam {
    id: number;
    name: string;
}

@Injectable()
export class RegionService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }
    // fetch All Region
    getAllRegion(pageNumber: any, limit: any): Observable<any> {
        const me = this;
        const regionListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        me.apiRequest.get(this.appConfig.region_url , params).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                });
            });
            const regionObj = Object.assign({}, jsonResp, {
                data: items
            });
            regionListSubject.next(regionObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return regionListSubject;
    }
    // save region
    save(region: Region): Observable<any> {
        const me = this;

        const bodyData: RegionRequestParam = <RegionRequestParam> {
            'name': region.name
        };

        const regionDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.region_url, bodyData)
            .subscribe(jsonResp => {
                    let regionInfoReturn: RegionRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const region: Region = jsonResp.data[0];

                        regionInfoReturn = <RegionRequestParam>{
                             'name': region.name
                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    regionDataSubject.next(regionInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return regionDataSubject;
    }
    // update region
    update(region: Region, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': region.id,
            'name': region.name
        };

        const regionDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.region_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let regionInfoReturn: RegionRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const cc: Region = jsonResp.data[0];
                        regionInfoReturn =  <RegionRequestParam> {
                            'id': cc.id,
                            'name': cc.name,
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    regionDataSubject.next(regionInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return regionDataSubject;
    }

    deleteRegion(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.region_url + '/' + id);
    }

    getAllRegionDD() {
        const me = this;
        return me.apiRequest.get(this.appConfig.region_dd_url);
    }
    getSitesByRegion(id: number) {
        const me = this;
        return me.apiRequest.get(this.appConfig.region_url + '/' + id + '/dd/sites');
    }

}
